import { render, staticRenderFns } from "./AddChapter.vue?vue&type=template&id=649dccdb&"
import script from "./AddChapter.vue?vue&type=script&lang=js&"
export * from "./AddChapter.vue?vue&type=script&lang=js&"
import style0 from "./AddChapter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports